import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TermsOfUseService } from 'app/services/terms-of-use.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export type TermsConditionsDialogData = {
    lang?: string;
};

@Component({
    selector: 'app-terms-conditions-dialog',
    templateUrl: './terms-conditions-dialog.component.html',
    styleUrls: ['./terms-conditions-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TermsConditionsDialogComponent implements OnInit {
    loading = true;
    loadError = false;
    contentHtml: SafeHtml | null = null;
    dialogTitle = '';

    constructor(
        public dialogRef: MatDialogRef<TermsConditionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TermsConditionsDialogData,
        private _termsOfUseService: TermsOfUseService,
        private _sanitizer: DomSanitizer
    ) {}

    /** CRM / API language id for content lookup */
    get contentLang(): string {
        const lang = (this.data?.lang || 'en').replace('-', '_');
        if (lang === 'es' || lang === 'es_AR') {
            return 'es_AR';
        }
        if (lang === 'en_US') {
            return 'en';
        }
        return lang || 'en';
    }

    ngOnInit(): void {
        this.loadContent();
    }

    private loadContent(): void {
        this.loading = true;
        this.loadError = false;
        this.contentHtml = null;
        this._termsOfUseService
            .getPublic(this.contentLang)
            .pipe(catchError(() => of(null)))
            .subscribe((payload) => {
                const html = (payload?.content || '').trim();
                if (html) {
                    this.dialogTitle = payload.title || '';
                    this.contentHtml = this._sanitizer.bypassSecurityTrustHtml(html);
                    this.loading = false;
                    this.loadError = false;
                    return;
                }
                // Requested language empty — try English once
                if (this.contentLang !== 'en') {
                    this._termsOfUseService
                        .getPublic('en')
                        .pipe(catchError(() => of(null)))
                        .subscribe((enPayload) => {
                            const enHtml = (enPayload?.content || '').trim();
                            if (enHtml) {
                                this.dialogTitle = enPayload.title || payload?.title || '';
                                this.contentHtml = this._sanitizer.bypassSecurityTrustHtml(enHtml);
                                this.loading = false;
                                this.loadError = false;
                                return;
                            }
                            this.dialogTitle = payload?.title || enPayload?.title || '';
                            this.loading = false;
                            this.loadError = true;
                        });
                    return;
                }
                this.dialogTitle = payload?.title || '';
                this.loading = false;
                this.loadError = true;
            });
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
